import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'

/**
 * RoleRoute - Route protection based on user role
 * @param {string[]} allowedRoles - Array of roles that can access this route
 * @param {React.ReactNode} children - Child components to render
 */
function RoleRoute({ allowedRoles = [], children }) {
  const { user } = useAuthStore()

  // Check if user has required role
  if (allowedRoles.length > 0 && user) {
    if (!allowedRoles.includes(user.role)) {
      // User doesn't have required role - redirect to home
      return <Navigate to="/" replace />
    }
  }

  return children
}

export default RoleRoute
